<template>
  <div id="map"></div>
</template>

<script>
import map from './AppMap.js'
export default {
  name: 'AppMap',
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
    map.init('map', () => {
      this.$emit('loaded')
    })
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>
<style>
#map .town-name,
#map .town-volumn {
  color: #c3dfff;
  margin: 0;
  padding: 0;
}
#map .town-name {
  font-size: 14px;
  font-weight: bold;
}
#map .town-volumn {
  font-size: 11px;
}

#map .enterprise-name,
#map .enterprise-volumn {
  color: #fff3df;
  margin: 0;
  padding: 0;
}
#map .enterprise-name {
  font-size: 14px;
  font-weight: bold;
}
#map .enterprise-volumn {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppMap.vue